import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import { isMobileFun, getPrefixField, convertStylesStringToObject, createFilePath, getPathnameByPosition } from '../../utils/obj-utils';
import { getQueryVariable } from '../../utils/site-utils';
import Detailss from '../../elements/InnerPageDetail';
import Details from '../Contrast_v1/details/index';
import './style.scss';

export default function index(props) {
  const { fields } = props;
  const isMobile = isMobileFun();
  const [tabIndex, setTabIndex] = useState(0);
  const [flag, setFlag] = useState(false);
  const [flag2, setFlag2] = useState(false);
  const [tabsflag, setTabsflag] = useState(true);
  const [btnindex, setBtnindex] = useState(0);
  const [carList, setCarList] = useState(null);
  const id = props?.params?.pagename;

  // sectionAction
  useImperativeHandle(props.eventRef, () => {
    return {
      sendEvent
    };
  });
  const sendEvent = () => {
    window.Dmp.sectionAction(id);
    window.navigationIndex = props.fields.navigationIndex.value;
    window.navigationPagename = window.navigationPagenameb = id !== undefined ? id : '';
  };
  // tabs
  useEffect(() => {
    const queryTabDefault = (value) => {
      let defaultIndex = -1;
      fields?.tabs.map((item, index) => {
        let tabArr = item.fields?.tabname?.value.split(',').map((tItem) => tItem.toLowerCase());
        if (tabArr.includes(value)) {
          defaultIndex = index;
        }
      });
      return defaultIndex;
    };
    const timer = setTimeout(() => {
      let tab = getQueryVariable('tab');
      let defaultTabInd = queryTabDefault(fields.tabsdefault?.value?.toLowerCase());
      if (tab) {
        let tabInd = queryTabDefault(tab.toLowerCase());
        setTabIndex(tabInd < 0 ? (defaultTabInd < 0 ? tabIndex : defaultTabInd) : tabInd);
      } else {
        setTabIndex(defaultTabInd < 0 ? tabIndex : defaultTabInd);
      }
    }, 100);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const tabClick = (item, index) => {
    setTabsflag(false);
    setTimeout(() => {
      setTabsflag(true);
    }, 10);
    setTabIndex(index);
    window.Dmp.clickAction(item?.fields?.tabsdmp?.value);
  };

  return (
    <div className="Detail_v2" id={id}>
      <div className="hash"></div>
      <div className="con" style={convertStylesStringToObject(fields[`${getPrefixField('constyle', isMobile)}`]?.value)}>
        {fields?.tabs && fields?.tabs.length > 0 && (
          <div
            className={`tabs tabs${fields?.tabs.length}`}
            style={convertStylesStringToObject(fields[`${getPrefixField('tabsstyle', isMobile)}`]?.value)}
          >
            {fields?.tabs.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  <div
                    className={`item ${index === tabIndex ? 'on' : ''}`}
                    onClick={() => tabClick(item, index)}
                    dangerouslySetInnerHTML={{ __html: item?.fields[`${getPrefixField('title', isMobile)}`]?.value?.replaceHtml() }}
                  ></div>
                </React.Fragment>
              );
            })}
          </div>
        )}
        {fields?.tabs.length > 0 && tabsflag && (
          <>
            <div className="top">
              {fields?.tabs[tabIndex]?.fields[`${getPrefixField('lo', isMobile)}`]?.value && (
                <img
                  className="lo"
                  style={convertStylesStringToObject(fields?.tabs[tabIndex]?.fields[`${getPrefixField('lostyle', isMobile)}`]?.value)}
                  src={createFilePath(fields?.tabs[tabIndex]?.fields[`${getPrefixField('lo', isMobile)}`]?.value)}
                  alt="广汽本田"
                />
              )}
              {fields?.tabs[tabIndex]?.fields[`${getPrefixField('pricehtml', isMobile)}`]?.value && (
                <div
                  className="price"
                  dangerouslySetInnerHTML={{
                    __html: fields?.tabs[tabIndex]?.fields[`${getPrefixField('pricehtml', isMobile)}`]?.value?.replaceHtml()
                  }}
                ></div>
              )}
            </div>
            <div className="lists">
              {fields?.tabs[tabIndex]?.fields[`${getPrefixField('attr1', isMobile)}`]?.value && (
                <div className="item">
                  <div
                    className="attr1"
                    dangerouslySetInnerHTML={{ __html: fields?.tabs[tabIndex]?.fields[`${getPrefixField('attr1', isMobile)}`]?.value?.replaceHtml() }}
                  ></div>
                </div>
              )}
              <div className="item">
                {!isMobile && (
                  <img
                    className="car"
                    style={convertStylesStringToObject(fields?.tabs[tabIndex]?.fields[`${getPrefixField('carstyle', isMobile)}`]?.value)}
                    src={createFilePath(fields?.tabs[tabIndex]?.fields[`${getPrefixField('car', isMobile)}`]?.value)}
                    alt="广汽本田"
                  />
                )}
                <div
                  className="attr2"
                  dangerouslySetInnerHTML={{ __html: fields?.tabs[tabIndex]?.fields[`${getPrefixField('attr2', isMobile)}`]?.value?.replaceHtml() }}
                ></div>
              </div>
              {isMobile && fields?.tabs[tabIndex]?.fields[`${getPrefixField('car', isMobile)}`]?.value && (
                <img
                  className="car"
                  style={convertStylesStringToObject(fields?.tabs[tabIndex]?.fields[`${getPrefixField('carstyle', isMobile)}`]?.value)}
                  src={createFilePath(fields?.tabs[tabIndex]?.fields[`${getPrefixField('car', isMobile)}`]?.value)}
                  alt="广汽本田"
                />
              )}
            </div>
            <div
              className="attr3Tips"
              dangerouslySetInnerHTML={{ __html: fields?.tabs[tabIndex]?.fields[`${getPrefixField('attr3', isMobile)}`]?.value?.replaceHtml() }}
            ></div>
            <div className="bottom">
              {fields?.tabs[tabIndex]?.fields?.btnlists.length > 0 &&
                fields?.tabs[tabIndex]?.fields?.btnlists.map((item, index) => {
                  return (
                    <div
                      className={`btn_v1 btn_v1_${index + 1}`}
                      key={index}
                      style={convertStylesStringToObject(item?.fields[`${getPrefixField('btnstyle', isMobile)}`]?.value)}
                      dangerouslySetInnerHTML={{ __html: item?.fields[`${getPrefixField('btn', isMobile)}`]?.value?.replaceHtml() }}
                      onClick={() => {
                        if (item?.fields?.isloan?.value) {
                          setFlag2(true);
                          const carList = fields?.tabs?.reduce(
                            (prev, cur) => [
                              ...prev,
                              {
                                carName: cur.fields.title_text.value,
                                GuidancePrice: parseFloat(cur.fields.price.value),
                                GuidanceUnit: item.fields?.Unit?.value ? parseFloat(item.fields.Unit.value) : ''
                              }
                            ],
                            []
                          );
                          setCarList(carList);
                          console.log(carList);
                        } else {
                          setBtnindex(index);
                          setFlag(true);
                        }
                        window.Dmp.clickAction(item?.fields?.dmp?.value);
                      }}
                    ></div>
                  );
                })}
            </div>
          </>
        )}
      </div>
      {flag && <Detailss routePath={fields?.tabs[tabIndex]?.fields?.btnlists[btnindex]?.fields?.detailurl?.value} close={() => setFlag(false)} />}
      {flag2 && <Details key={Math.random()} carType={getPathnameByPosition()?.toLowerCase()} close={setFlag2} carList={carList} />}
    </div>
  );
}
